import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Updated CSS path
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card1 from "../Images/Profiles/Alex.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function AlexanderAtuyamba() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Alexander Atuyamba - Director / Agro Ecological Farming Systems Specialist"
        description="Alexander is a qualified professional with a Master's Degree in Agroecology and a Bachelor's degree in Organic Agriculture, both earned from Uganda Martyrs University. Additionally, he holds a Diploma in Forestry from Nyabyeya Forestry College Masindi, Uganda. Presently, Alexander serves as a Director and Research Consultant at the Center for Integrated Research and Community Development Uganda (CIRCODU), having been in this role for approximately 7 years. His primary focus areas encompass Forestry, Energy, and Agriculture."
        keywords="Alexander Atuyamba, Director, Agro Ecological Farming Systems Specialist, CIRCODU, Uganda Martyrs University, Nyabyeya Forestry College, Forestry, Energy, Agriculture, research consultant"
        url="/alexander-atuyamba"
        image={Card1}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Alexander Atuyamba</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Alexander Atuyamba
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card1} alt="Mr. Alexander Atuyamba" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Alexander Atuyamba</h1>
                <p className="profile-card__role">
                  Director / Agro Ecological Farming Systems Specialist
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Alexander is a qualified professional with a Master's Degree
                  in Agroecology and a Bachelor's degree in Organic Agriculture,
                  both earned from Uganda Martyrs University. Additionally, he
                  holds a Diploma in Forestry from Nyabyeya Forestry College
                  Masindi, Uganda.
                </p>
                <p>
                  Presently, Alexander serves as a Director and Research
                  Consultant at the Center for Integrated Research and Community
                  Development Uganda (CIRCODU), having been in this role for
                  approximately 7 years. His primary focus areas encompass
                  Forestry, Energy, and Agriculture.
                </p>
                <p>
                  In his capacity, Alexander efficiently coordinates
                  organizational activities in the realm of research and
                  consultancies on a daily basis. He leads and supervises a team
                  of 40 technical staff members, comprising both full-time and
                  part-time personnel.
                </p>
                <p>
                  Moreover, Alexander boasts a rich professional background
                  spanning over 8 years (2005-2012) during which he collaborated
                  with the Ministry of Water and Environment as a Forest
                  Plantations Officer. This engagement was under the purview of
                  a Commercial Forestry Project (SPGS) funded by the European
                  Union and Norwegian entities. His role within this project
                  exposed him to working intricately with Government Projects
                  and the Private sector, involving tasks such as devising
                  policy guidelines and crafting technical and financial
                  proposals and reports. The consequential outcome of this
                  project was the cultivation of a robust culture of tree
                  growing in Uganda, with over 50,000 hectares planted during
                  that period by around 300 private tree growers. An early
                  career milestone for Alexander was co-authoring Uganda's
                  inaugural tree planting guidelines in 2004.
                </p>
                <p>
                  Preceding this, from 2003 to 2005, Alexander embarked on his
                  initial agricultural venture, engaging with farmers in Kabale
                  district Local Government. In this capacity, he served as a
                  Service Provider with the National Agricultural Advisory
                  Services (NAADS) for a span of 2 years. During this formative
                  period, Alexander gained substantial experience collaborating
                  on local Government Projects and interacting directly with
                  community-based farmers. His primary responsibilities
                  encompassed offering guidance and disseminating knowledge and
                  skills pertaining to enhanced farming techniques and
                  agricultural development. Furthermore, he was tasked with
                  reporting to the Sub-County Farmers Forum Executive Committee,
                  delivering insights on agricultural performance in general, as
                  well as the progress of farmers' groups within his operational
                  areas.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/atuyamba-alex-43b18931/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/AtuyambaAlex"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Circodu/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256783430017"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:alex.atuyamba@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AlexanderAtuyamba;
